<template>
    <div class="list">
        <Modal v-model="modalShow" width="1000" :on-open-modal="modalShow=true" @on-cancel="onCancel" class-name="vertical-center-modal">
            <div class="texts">
                <p class="titles">{{curItemDetails.title}}</p>
                <!-- <p class="times">本次更新时间：{{curItemDetails.gmtModified}}</p> -->
            </div>
            <div class="curItemDetails">
                <div v-html="curItemDetails.content"></div>
            </div>
            <div slot="footer" class="footer">
                <!-- <Button @click="onCancel">关闭</Button> -->
                <span class="btn" @click="onCancel">关闭</span>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    props: {
        curItemDetails: Object,
    },
    data() {
        return {
            modalShow: false,
            formData: {},
        };
    },
    mounted() {},
    methods: {
        onCancel() {
            this.$emit("on-close-cancel", false);
        },
    },
};
</script>

<style lang='less'>
.ivu-modal-wrap {
  left: 0!important;
}
.ivu-modal-content p {
    word-break: break-all !important;
}
.curItemDetails {
    height: 300px;
    overflow-y: scroll;
}
// .vertical-center-modal {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     .ivu-modal {
//         top: 0;
//     }
// }
</style>
<style lang='less' scoped>
.texts {
    text-align: center;

    .titles {
        font-size: 26px;
        font-weight: 600;
        color: #111111;
    }
    .times {
        font-size: 12px;
        font-weight: 400;
        color: #555555;
        margin-bottom: 10px;
        margin-top: 10px;
    }
}
.footer {
    text-align: center;
    .btn {
        font-size: 20px;
  
        font-weight: 400;
        color: #0c479d;
        line-height: 20px;
        cursor: pointer;
    }
}
</style>